var checkoutApiMixin = (function (Backbone, api) {
	var checkoutStoreDispatcher = _.clone(Backbone.Events);
    var updateCheckoutEvent = '_updateCheckout';

    var errorReasons = {
        itemNonLongerAvailable: '_SomeItemsAreNoLongerAvailable'
    };

    var customerName;

	var auth = null;

    var _getGuestUserData = function(data) {
        data = data || {};
        app.customerEmailModel.getValidatedEmail();
        data.email = app.customerEmailModel.get('email');
        data.name = window.__checkoutModel__.get('Delivery').get('Current').get('Name') || '';
        data.parameters = {};
        data.parameters.tcAccepted = app.customerEmailModel.getTC();
        data.parameters.emailsAccepted = app.customerEmailModel.getEmailAccept();
        return data;
    };

    var _isAuthorized = function () {
		// TODO: cache is needed, do not remove. some public methods sets auth cookies.
		if (auth !== null) {
			return auth;
		}
		var r = !(app.cookie.get('us') === null || app.cookie.get('us') === 'unl');
		auth = r;
	    return r;
	};

    var _parseAvailablePaymentMethods = function (data) {
        var settings = CheckoutSettings.getBasketSettings();
        if (!settings.StripeEnabledWithOurPay && data.Value.MyPayDetails && data.Value.MyPayDetails.Enabled) {
            data.Value.AvailablePaymentOptions = data.Value.AvailablePaymentOptions.filter(function (m) {
                return !m.Name.match(/stripe/gi);
            });
        }
        return data;
    };

	window.__isAuthorized__ = _isAuthorized;

    var _valuePromise = function (value) {
        return new $.Deferred().resolve({
            Message: "",
            Result: true,
            Value: value
        }).promise();
    };

    /* Get Delivery Details */
    var _getDeliveryDetails = function () {
        return null;
    }

    var isGuest = (app.cookie.get('us') === null || app.cookie.get('us') === 'unl');
    app.event = window.app && app.events && app.events.initCheckoutEvents(isGuest, true);
    window.__isMobile__ = true;

    var _handlePaymentExeption = function(result, updateCheckout) {
        if (result && result.Value === errorReasons.itemNonLongerAvailable) {
            if (window.app && app.event && app.event.itemNonLongerAvailable) {
                app.event.itemNonLongerAvailable();
            }
            updateCheckout && updateCheckout();
            if (window.BaseView) {
                var b = new BaseView({});
                b._displayRouter.display('checkout');
            }
        }
    };

    var _api = {
        getUserAddresses: function () {
			if (_isAuthorized()) {
                return api.getUserAddresses();
            } else {
                return _valuePromise([]);
            }
        },
        getBraintreeUserPaymentMethods: function () {
			if (_isAuthorized()) {
                return api.getBraintreeUserPaymentMethods({ hideErrors: true })
                    .then(function(result) {
                        _.each(result.Value.PaymentMethods, function(method) {
                            method.PaymentType = PaymentTypes.get(method.PaymentType);
                        });
                        if (!result.Value.LastPaidToken) {
                            var method = result.Value.PaymentMethods && result.Value.PaymentMethods[0] || {}
                            result.Value.LastPaidToken = method.Token || null;
                        }
                        return result;
                    });
            } else {
                return _valuePromise([]);
            }
        },
        getDeliveryServicePackageDetails: function () {
            if (!app.settings.get('UseGuestCheckout') || _isAuthorized()) {
                return api.getDeliveryServicePackageDetails();
            } else {
                return api.getPublicDeliveryServicePackageDetails();
            }
        },
        increaseOrderItem: function (id, imageSize) {
            var _deliveryDetails = _getDeliveryDetails();
            var postdata = { 'itemID': id, 'imageSize': imageSize, 'deliveryDetails': _deliveryDetails };

            if (!app.settings.get('UseGuestCheckout') || _isAuthorized()) {
                return api.increaseOrderItem(postdata, { abortOnRetry: false });
            } else {
                return api.increasePublicOrderItem(postdata, { abortOnRetry: false });
            }
        },
        decreaseOrderItem: function (id, imageSize) {
            var _deliveryDetails = _getDeliveryDetails();
            var postdata = { 'itemID': id, 'imageSize': imageSize, 'deliveryDetails': _deliveryDetails };

            if (!app.settings.get('UseGuestCheckout') || _isAuthorized()) {
                return api.decreaseOrderItem(postdata, { abortOnRetry: false });
            } else {
                return api.decreasePublicOrderItem(postdata, { abortOnRetry: false });
            }
        },
        deleteOrderItem: function (id) {
            var _deliveryDetails = _getDeliveryDetails();
            var postdata = { 'itemID': id, 'deliveryDetails': _deliveryDetails };

            if (!app.settings.get('UseGuestCheckout') || _isAuthorized()) {
                return api.deleteOrderItem(postdata, { abortOnRetry: false });
            } else {
                return api.deletePublicOrderItem(postdata, { abortOnRetry: false });
            }
        },
        applyDeliveryAddress: function (deliveryAddressID, imgSize) {
            if (!app.settings.get('UseGuestCheckout') || _isAuthorized()) {
                return api.applyDeliveryAddress(deliveryAddressID, imgSize, { abortOnRetry: false });
            } else {
                var deferred = new $.Deferred();
                deferred.reject({
                    d: {
                        Result: false
                    }
                });
                return deferred.promise();
            }
        },
        setUserDeliveryAddress: function (address) {
            if (!app.settings.get('UseGuestCheckout') || _isAuthorized()) {
                return api.setUserDeliveryAddress(address)
                    .then(function (data) {
                        if (data.Value) {
                            return api.applyDeliveryAddress(data.Value, CheckoutSettings.imageSize);
                        } else {
                            return PromiseUtil.rejected();
                        }
                    });
            } else {
			    var data = _getGuestUserData();
			    data.name = address.Name;
			    if (data.email) {
			        return api.setPublicDeliveryAddress(address, data);
			    } else {
			        return new $.Deferred().reject().promise();
			    }
            }
        },
        setUserBillingAddress: function (address) {
            if (!app.settings.get('UseGuestCheckout') || _isAuthorized()) {
                return api.setUserBillingAddress(address);
            } else {
			    var data = _getGuestUserData();
			    data.name = address.Name;
			    if (data.email) {
			        return api.setPublicBillingAddress(address, data);
			    } else {
			        return new $.Deferred().reject().promise();
			    }
            }
        },
        setUserGiftAddress: function (address) {
            if (!app.settings.get('UseGuestCheckout') || _isAuthorized()) {
                return api.setUserGiftAddress(address);
            } else {
			    var data = _getGuestUserData();
			    data.name = address.Name;
			    if (data.email) {
			        return api.setUserPublicGiftAddress(address, data);
			    } else {
			        return new $.Deferred().reject().promise();
			    }
            }
        },
        getUserGiftAddresses: function () {
            if (!app.settings.get('UseGuestCheckout') || _isAuthorized()) {
                return api.getUserGiftAddresses();
            } else {
			    return new $.Deferred().resolve(null).promise();
            }
        },
        getPickupPointsByPostcode: function (postcode) {
            if (!app.settings.get('UseGuestCheckout') || _isAuthorized()) {
                return api.getPickupPointsByPostcode({ postcode: postcode }, { hideErrors: true });
            } else {
                return api.getPickupPointsByPostcode({ postcode: postcode }, { hideErrors: true });
            }
        },
        getPickupPointsByCoordinates: function (data) {
            if (!app.settings.get('UseGuestCheckout') || _isAuthorized()) {
                return api.getPickupPointsByCoordinates(data, { hideErrors: true });
            } else {
                return api.getPickupPointsByCoordinates(data, { hideErrors: true });
            }
        },
        setDeliveryOption: function (data) {
            var _deliveryDetails = _getDeliveryDetails();
            var postdata = { 'optionParameters': data, 'imageSize': CheckoutSettings.imageSize, 'deliveryDetails': _deliveryDetails };

            if (!app.settings.get('UseGuestCheckout') || _isAuthorized()) {
                return api.setDeliveryOption(postdata, { wait: true, delay: 1000 });
            } else {
                return api.setPublicDeliveryOption(postdata, { wait: true, delay: 1000 });
            }
        },
        normalizePhoneAndSendCode: function (phone) {
            if (!app.settings.get('UseGuestCheckout') || _isAuthorized()) {
                return api.normalizePhoneAndSendCode(phone, { preventDoubleRequests: true });
			} else {
			    var data = _getGuestUserData();
                if (data.email) {
                    return api.publicNormalizePhoneAndSendCode(phone, data, { preventDoubleRequests: true });
                } else {
                    return new $.Deferred().reject().promise();
                }
            }
        },
        verificationCodeConfirm: function (phone, code) {
            if (!app.settings.get('UseGuestCheckout') || _isAuthorized()) {
                return api.verificationCodeConfirm(phone, code, { preventDoubleRequests: true });
			} else {
			    var data = _getGuestUserData();
                return api.verificationPublicCodeConfirm(phone, code, data, { preventDoubleRequests: true });
            }
		},
        setAuthToLeave: function (data) {
            if (!app.settings.get('UseGuestCheckout') || _isAuthorized()) {
                return api.setAuthToLeave(data);
            } else {
                return api.setPublicAuthToLeave(data);
            }
        },
        addAndApplyVoucherByKey: function (value) {
            var _deliveryDetails = _getDeliveryDetails();
            var postdata = { 'key': value, 'imageSize': CheckoutSettings.imageSize, 'deliveryDetails': _deliveryDetails };

            if (!app.settings.get('UseGuestCheckout') || _isAuthorized()) {
                return api.addAndApplyVoucherByKey(postdata);
            } else {
                return api.addAndApplyPublicVoucherByKey(postdata);
            }
        },
        applyVoucher: function (id) {
            var _deliveryDetails = _getDeliveryDetails();
            var postdata = { 'voucherID': id, 'imageSize': CheckoutSettings.imageSize, 'deliveryDetails': _deliveryDetails };

            return api.applyVoucher(postdata, { wait: true });
        },
        removeVoucher: function (id) {
            var _deliveryDetails = _getDeliveryDetails();
            var postdata = { 'voucherID': id, 'imageSize': CheckoutSettings.imageSize, 'deliveryDetails': _deliveryDetails };

            return api.removeVoucher(postdata, { wait: true });
        },
        removeVoucherByKey: function (value) {
            var _deliveryDetails = _getDeliveryDetails();
            var postdata = { 'key': value, 'imageSize': CheckoutSettings.imageSize, 'deliveryDetails': _deliveryDetails };

            return api.removeVoucherByKey(postdata);
        }
    };

	return {
		_checkoutStoreDispatcher: checkoutStoreDispatcher,

        _api: _api,

        _isAuthorized: _isAuthorized,

        _getGuestUserData: _getGuestUserData,

		_createPaymentTransaction: function (data, settings) {
            var _block = $.tmpl('bt-checkout-transaction-progress-block').appendTo('body');
            if (!app.settings.get('UseGuestCheckout') || _isAuthorized()) {
                return api.createPaymentTransaction({ data: data }, settings)
                    .fail(_.bind(function (result) {
                        _block.remove();
                        _handlePaymentExeption(result, _.bind(this.update_checkout, this));
                    }, this))
                    .always(function () {
                        _block.remove();
                    });
            } else {
                return api.createPublicPaymentTransaction({ data: this._getGuestUserData(data) }, settings)
                    .fail(_.bind(function (result) {
                        _handlePaymentExeption(result, _.bind(this.update_checkout, this));
                        _block.remove();
                    }, this))
                    .always(function () {
                        _block.remove();
                    });
            }
		},

        _createAfterpayOrder: function (url, afterpaySrc) {
            var xhr;
            if (!app.settings.get('UseGuestCheckout') || _isAuthorized()) {
                xhr = api.createAfterpayOrder(url);
            } else {
                var data = this._getGuestUserData();
                xhr = api.createPublicAfterpayOrder(url, data);
            }
            
            var loadXHR = AfterpayHelper.load(afterpaySrc);
            $.when(xhr, loadXHR).done(function (data) {
                data = data && data.Value || null;
                if (data && data.isSuccess && data.token && window.AfterPay) {
                    AfterPay.initialize({ countryCode: GlobalSettings.Iso.toUpperCase() });
                    AfterPay.redirect({ token: data.token });
                }
            });
        },

        _createOpenpayOrder: function (url) {
            var xhr;
            if (!app.settings.get('UseGuestCheckout') || _isAuthorized()) {
                xhr = api.createOpenpayOrder(url);
            } else {
                var data = this._getGuestUserData();
                xhr = api.createPublicOpenpayOrder(url, data);
            }
            $.when(xhr).done(function (data) {
                data = data && data.Value || null;
                if (data && data.isSuccess) {
                    window.location = data.postUrl;    
                } else {
                        alert(kos.getPageTemplate('GeneralTechnicalDifficulties'));
                }
            });
        },

		_afterPayCreatePayment: function (token) {
            var afterpayResult;
            var _this = this;
            var afterpayDef = new $.Deferred();
            if (!app.settings.get('UseGuestCheckout') || _isAuthorized()) {
                afterpayResult = api.afterPayCreatePayment({ token: token }, { wait: true, hideErrors: true });
            } else {
                afterpayResult = api.afterPayCreatePublicPayment({ token: token }, { wait: true, hideErrors: true });
            }
            afterpayResult.done(afterpayDef.resolve)
                .fail(function (data) {
                    if (data && data.Result === false && data.Message) {
                        if (data.Value && data.Value.isPaid === false) {
                            _this.update_checkout();
                        }
                        alert(data.Message);
                    }
                    afterpayDef.reject();
                });
            return afterpayDef.promise();
        },
        
        _openpayCapturePayment: function (postdata) {
            var openpayResult;
            var _this = this;
            var openpayDef = new $.Deferred();
            if (!app.settings.get('UseGuestCheckout') || _isAuthorized()) {
                openpayResult = api.openpayCapturePayment({ planId: postdata.planId, orderId: postdata.orderId, status: postdata.status }, { wait: true, hideErrors: true });
            } else {
                openpayResult = api.openpayCapturePublicPayment({ planId: postdata.planId, user: postdata.user, orderId: postdata.orderId, status: postdata.status }, { wait: true, hideErrors: true });
            }
            openpayResult.done(openpayDef.resolve)
                .fail(function (data) {
                    if (data && data.Result === false && data.Message) {
                        if (data.Value && data.Value.isPaid === false) {
                            _this.update_checkout();
                        }
                        alert(data.Message);
                    }
                    openpayDef.reject();
                });
            return openpayDef.promise();
        },

        _updateCheckout: function (data) {
            var ourpay = ourpay_data_mapper(data.Value);
            data.Value.MyPayDetails = ourpay.MyPayDetails;

            data = _parseAvailablePaymentMethods(data);

            // customerName = data.Value.DeliveryAddress.Name;
			checkoutStoreDispatcher.trigger(updateCheckoutEvent, data);
        },

		_onUpdateCheckout: function (cb) {
			checkoutStoreDispatcher.on(updateCheckoutEvent, cb);
        },

        update_checkout: function () {
            if (!app.settings.get('UseGuestCheckout') || _isAuthorized()) {
                api.getCurrentOrder({ imageSize: CheckoutSettings.imageSize, deliveryDetails: null }, { serverErrorHandleOption: api.RedirectionOptionsEnum.PopupMessage }).done(this._updateCheckout);
            } else {
                api.getPublicCurrentOrder({ imageSize: CheckoutSettings.imageSize, deliveryDetails: null }, { serverErrorHandleOption: api.RedirectionOptionsEnum.PopupMessage }).done(this._updateCheckout);
            }
        }
	};
})(Backbone, api);

var CheckoutApiModel = (function (Model, checkoutApiMixin) {
	return Model.extend(checkoutApiMixin);
})(Backbone.Model, checkoutApiMixin);

var CheckoutApiCollection = (function (Collection, checkoutApiMixin) {
	return Collection.extend(checkoutApiMixin);
})(Backbone.SmartCollection, checkoutApiMixin);